const stockTransferStatusLabels = {
  pending: "دیده نشده",
  approved: "قبول درخواست",
  rejected: "رد درخواست",
  incomplete: "محموله ناقص",
  completed: "تکمیل شده",
  inTransit: "در حال ارسال",
  canceled: "لغو شده"
}

export default stockTransferStatusLabels